export function EmptyState({ message }: { message: string }) {
  return (
    <div className="rounded-2xl border border-dashed border-[#ccd1dd] px-4 py-7 text-center
                    text-[13px] font-medium text-[#7c8393]">
      {message}
    </div>
  );
}
